import RemoveFromCatalogModal from "./RemoveFromCatalogModal";

export default RemoveFromCatalogModal;
